import Web3 from "web3";
import CryptoJS from "crypto-js";
import Config, {
  PAYMENT_SUPPORT,
  SUPPORTED_CHAINS,
} from "../utils/constants/config";

import messages from "../utils/constants/messages";
import { getDecriptedEnv } from "../actions/DataActions";

// import { PAYMENT_ABI, TVK_ABI }  from `../utils/utilities/${Config.ENV.toLowerCase()}_abi`
const {
  PAYMENT_ABI,
  TVK_ABI,
} = require(`../utils/utilities/${Config.ENV.toLowerCase()}_abi`);


const PAYMENT_CONTRACT = process.env.REACT_APP_PAYMENT_CONTRACT_ADDRESS;

export const gerUserTokenBalance = async (
  address,
  payment_support = PAYMENT_SUPPORT.TVK,
  library
) => {
  let web3 = new Web3(library.provider);
  if (payment_support == PAYMENT_SUPPORT.TVK) {
    const tvkContract = new web3.eth.Contract(
      TVK_ABI,
      process.env.REACT_APP_TVK_CONTRACT_ADDRESS
    );

    try {
      let response = await tvkContract.methods.balanceOf(address).call();

      let weiBalance = web3.utils.fromWei(response);

      return Number(weiBalance);
    } catch (error) {
      console.log("err", error);
      return -1;
    }
  } else {
    let response = await web3.eth.getBalance(address);
    let weiBalance = web3.utils.fromWei(response);

    return Number(weiBalance);
  }
};
export const getAllownceAmountToContract = async (address, library) => {
  let web3 = new Web3(library.provider);
  const tvkContract = new web3.eth.Contract(
    TVK_ABI,
    process.env.REACT_APP_TVK_CONTRACT_ADDRESS
  );

  let response = await tvkContract.methods
    .allowance(address, PAYMENT_CONTRACT)
    .call();

  let weiBalance = web3.utils.fromWei(response);

  return weiBalance;
};
export const getApproveAllownceAmountToContract = async (
  address,
  ammount,
  library
) => {
  try {
    let web3 = new Web3(library.provider);

    const tvkContract = new web3.eth.Contract(
      TVK_ABI,
      process.env.REACT_APP_TVK_CONTRACT_ADDRESS
    );
    // increaseAllowance
    let response = await tvkContract.methods
      .increaseAllowance(
        PAYMENT_CONTRACT,
        web3.utils.toWei(String(ammount), "ether")
      )
      .send({ from: address });

    // let data = tx.encodeABI();

    // let _gas;

    // _gas = await tx.estimateGas({
    //   from: address,
    // });

    // let hexGas = web3.utils.toHex(_gas);
    // let response = await web3.currentProvider.request({
    //   method: "eth_sendTransaction",
    //   params: [
    //     {
    //       from: address,
    //       to: PAYMENT_CONTRACT,
    //       gas: hexGas,
    //       value: 0,
    //       data: data,
    //     },
    //   ],
    // });

    // let approveRes = web3.utils.fromWei(response);

    return response;
  } catch (error) {
    console.log("===>>", error);
    throw {
      code: 4001,
      message: messages.approval_request_rejected,
    };
  }
};
export const getSignedAddress = async (keys, address) => {
  try {
    keys = getDecriptedEnv(keys);
    let ciphertext = CryptoJS.AES.encrypt(address, keys.enc_hash).toString();

    return ciphertext;
  } catch (error) {
    return null;
  }
};

export const getPlotPrice = async (
  plotType,
  payment_support = PAYMENT_SUPPORT.TVK,
  library
) => {
  let web3 = new Web3(library.provider);
  const buyContract = new web3.eth.Contract(PAYMENT_ABI, PAYMENT_CONTRACT);

  try {
    let _priceInTVK =
      payment_support == PAYMENT_SUPPORT.TVK
        ? await buyContract.methods.getlandPriceInTVK(plotType).call()
        : await buyContract.methods.getlandPriceInETH(plotType).call();
    return _priceInTVK ? web3.utils.fromWei(_priceInTVK) : -1;
  } catch (error) {
    console.log(error, "error with TVK");
    return -1;
  }
};

export const buyPlot = async (
  address,
  slot_id,
  plot_id,
  plotSize,
  hash,
  signature,
  payment_support = PAYMENT_SUPPORT.TVK,
  eithPlotPrice,
  library
) => {
  try {
    let web3 = new Web3(library.provider);
    const buyContract = new web3.eth.Contract(PAYMENT_ABI, PAYMENT_CONTRACT);

    if (payment_support == PAYMENT_SUPPORT.TVK) {
      let tx = await buyContract.methods.buyLandWithTVK(
        slot_id,
        plotSize,
        plot_id,
        hash,
        signature
      );
      let data = tx.encodeABI();

      let _gas;

      _gas = await tx.estimateGas({
        from: address,
      });

      let hexGas = web3.utils.toHex(_gas);
      let response = await web3.currentProvider.request({
        method: "eth_sendTransaction",
        params: [
          {
            from: address,
            to: PAYMENT_CONTRACT,
            // gas: hexGas,
            value: 0,
            data: data,
          },
        ],
      });

      return { status: true, response: response };
    } else {
      let tx = await buyContract.methods.buyLandWithETH(
        slot_id,
        plotSize,
        plot_id,
        hash,
        signature
      );

      let data = tx.encodeABI();

      let value = web3.utils.toHex(
        web3.utils.toWei(String(eithPlotPrice), "ether")
      );
      let _gas;

      _gas = await tx.estimateGas({
        from: address,
        value: value,
      });

      let hexGas = web3.utils.toHex(_gas);
      let response = await web3.currentProvider.request({
        method: "eth_sendTransaction",
        params: [
          {
            from: address,
            to: PAYMENT_CONTRACT,
            // gas: hexGas,
            value: value,
            data: data,
          },
        ],
      });

      return { status: true, response: response };
    }
  } catch (error) {
    console.log("buyPlot===>>>", error);
    if (error?.code === 4001) {
      error.message = messages.payment_request_rejected;
      return { status: false, response: error };
    }

    if (Object.keys(error)?.length == 0) {
      error = error.toString();
      var open = error.indexOf("{");
      var close = error.lastIndexOf("}");
      var replacedString = error.substring(open, close + 1);

      try {
        let parsedData = JSON.parse(
          replacedString
            ?.replace("execution reverted: Landsale:", "")
            ?.replace("execution reverted:", "")
        );

        return { status: false, response: parsedData };
      } catch (exc) {}
    }

    return { status: false, response: error };
  }
};

export const buyCondo = async (
  address,
  slot,
  condoID,
  type,
  hash,
  signature,
  payment_support = PAYMENT_SUPPORT.TVK,
  eithPlotPrice,
  library
) => {
  try {
    let web3 = new Web3(library.provider);
    const buyContract = new web3.eth.Contract(PAYMENT_ABI, PAYMENT_CONTRACT);

    if (payment_support == PAYMENT_SUPPORT.TVK) {
      let tx = await buyContract.methods.buyLandWithTVK(
        slot,
        type,
        condoID,
        hash,
        signature
      );
      let data = tx.encodeABI();

      let _gas;

      _gas = await tx.estimateGas({
        from: address,
      });

      let hexGas = web3.utils.toHex(_gas);
      let response = await web3.currentProvider.request({
        method: "eth_sendTransaction",
        params: [
          {
            from: address,
            to: PAYMENT_CONTRACT,
            // gas: hexGas,
            value: 0,
            data: data,
          },
        ],
      });
      return { status: true, response: response };
    } else {
      let tx = await buyContract.methods.buyLandWithETH(
        slot,
        type,
        condoID,
        hash,
        signature
      );

      let data = tx.encodeABI();

      let value = web3.utils.toHex(
        web3.utils.toWei(String(eithPlotPrice), "ether")
      );
      let _gas;

      _gas = await tx.estimateGas({
        from: address,
        value: value,
      });

      let hexGas = web3.utils.toHex(_gas);
      let response = await web3.currentProvider.request({
        method: "eth_sendTransaction",
        params: [
          {
            from: address,
            to: PAYMENT_CONTRACT,
            // gas: hexGas,
            value: value,
            data: data,
          },
        ],
      });

      return { status: true, response: response };
    }
  } catch (error) {
    if (error?.code === 4001) {
      error.message = messages.payment_request_rejected;
      return { status: false, response: error };
    }
    if (Object.keys(error)?.length == 0) {
      error = error.toString();
      var open = error.indexOf("{");
      var close = error.lastIndexOf("}");
      var replacedString = error.substring(open, close + 1);

      try {
        let parsedData = JSON.parse(
          replacedString
            ?.replace("execution reverted: Landsale:", "")
            ?.replace("execution reverted:", "")
        );

        return { status: false, response: parsedData };
      } catch (exc) {}
    }

    return { status: false, response: error };
  }
};

export const getAuthSignature = async (account, library, keys) => {
  try {
    // const signature = await web3.eth.personal.sign(
    //    ||

    //   account
    // );

    // return signature;
    keys = getDecriptedEnv(keys);
    const signer = library.getSigner(account);
    const signature = await signer.signMessage(keys.sign_hash);
    return signature;
  } catch (error) {
    console.log("signature===>>>", error);
    // if (error?.code == 4001)
    return null;

    // return getAuthSignatureUsingAccount(account);
  }
};

export const subscribeCalls = (library) => {
  let web3 = new Web3(library.provider);
  const tvkContract = new web3.eth.Contract(
    TVK_ABI,
    process.env.REACT_APP_PAYMENT_CONTRACT_ADDRESS
  );
  tvkContract.events
    .Approval({ fromBlock: "latest" }, function (error, event) {
      console.log(event);
    })
    .on("connected", function (subscriptionId) {
      console.log(subscriptionId);
    })
    .on("data", function (event) {
      console.log(event); // same results as the optional callback above
    })
    .on("changed", function (event) {
      console.log(event); // same results as the optional callback above
      // remove event from local database
    })
    .on("error", function (error, receipt) {
      console.log(error, receipt); // same results as the optional callback above
      // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
    });

  //   return web3.eth.subscribe(
  //     "logs",
  //     function (error, result) {
  //      console.log("pendingTransactions==",error,result);
  //     }
  //   );
};

export const checkNetwork = async (library) => {
  let web3 = new Web3(library.provider);

  const currentChainId = await web3.currentProvider.request({
    method: "eth_chainId",
  });

  if (SUPPORTED_CHAINS.includes(currentChainId)) {
    return true;
  } else {
    throw {
      status: false,
      message: messages.invalid_network,
    };
  }
};
